import React from 'react'

 function AdminHome() {
    
  return (
    <>
    <h2>Home page</h2>
    </>
  )
}
export default AdminHome